<template>
    <v-modal :is-open="isOpen"
        class="bg-white"
        @close="$emit('close')">
        <v-modal-header @close="$emit('close')">
            {{ t('filter-title') }}
        </v-modal-header>

        <div class="space-y-md px-10 pb-20">
            <v-info>
                <b>{{ t('filter-info', {results}) }}</b>
            </v-info>

            <v-category-filter-facet v-for="facet in facets"
                :key="facet.id"
                v-model="selectedFacets[facet.id]"
                :facet="facet" />
        </div>
    </v-modal>
</template>

<script lang="ts" setup>
import type { Facet } from '@apptus/esales-api';

defineProps<{
    isOpen: boolean
    results?: number
}>();

defineEmits<{
    (event: 'close'): void
}>();

const { t } = useI18n();

const facets = inject<Ref<Facet[]>>('facets', ref([]));
const selectedFacets = inject<Ref<Record<string, (string | number | boolean)[]>>>('activeFilters', ref({}));
</script>

<i18n lang="json">
{
    "et": {
        "filter-title": "Filtrid",
        "filter-info": "Sinu otsingule leiti {results} tulemust"
    },
    "fi": {
        "filter-title": "Suodattimet",
        "filter-info": "Haullesi löytyi {results} tulosta"
    }
}
</i18n>
